import { useAuth } from "../context/AuthContext";

export default function LoginButton() {
  const { user, isPremium, loginWithGoogle, logout } = useAuth();

  if (user) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img
          src={user.photoURL}
          alt={user.displayName}
          style={{ width: 32, height: 32, borderRadius: "50%" }}
        />
        <span style={{ fontSize: 14, color: "#e8e8f0" }}>
          {user.displayName}
          {isPremium && (
            <span style={{ marginLeft: 6, fontSize: 11, background: "#7F77DD", color: "#fff", padding: "2px 7px", borderRadius: 99, fontWeight: 600 }}>
              PRO
            </span>
          )}
        </span>
        <button
          onClick={logout}
          style={{ fontSize: 13, background: "none", border: "1px solid #2a2a3a", color: "#888", padding: "6px 12px", borderRadius: 8, cursor: "pointer" }}
        >
          Log out
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={loginWithGoogle}
      style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px", border: "1px solid #2a2a3a", borderRadius: 8, background: "#13131a", cursor: "pointer", fontSize: 14, fontWeight: 500, color: "#e8e8f0" }}
    >
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" width={18} height={18} alt="" />
      Sign in with Google
    </button>
  );
}